<template>
  <div>
    <b-table
      :items="events"
      :fields="fields"
      responsive
      show-empty
      :busy="busy"
    >
      <template #cell(start)="data">
        {{ formatDate(data.item.start, data.item.start_time) }}
      </template>

      <template #cell(end)="data">
        {{ formatDate(data.item.end, data.item.end_time) }}
      </template>

      <template #empty>
        Es gibt keine Termine
      </template>

      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle" />
          <strong> Laden...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BTable } from 'bootstrap-vue'

export default {
  name: 'CalendarList',
  components: {
    BTable
  },
  data () {
    return {
      fields: [
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'start',
          label: 'Start'
        },
        {
          key: 'end',
          label: 'Ende'
        },
        {
          key: 'description',
          label: 'Beschreibung'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('calendar', [
      'getEvents',
      'getCurrentMonthIsLoading'
    ]),
    events () {
      return this.getEvents
    },
    busy () {
      return this.getCurrentMonthIsLoading
    }
  },
  methods: {
    formatDate (oldDate, time = '00:00:00') {
      const date = new Date(oldDate)
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1

      return day + '.' + month + '.' + date.getFullYear() + ' ' + time.slice(0, -3)
    }
  }
}
</script>

<style scoped>

</style>
